import Actions          from "../../model/constant/actions"
import ReducerUtils     from "../../utils/ReducerUtils"

const NeedPermissionExtraData = ReducerUtils.createReducer<boolean>(true,{
  [Actions.RETRIEVE_USERS_LIST]                    : ()=>true,
  [Actions.RETRIEVE_USERS_PERMISSION_EXTRA_DATA]   : ()=>false,
  [Actions.RETRIEVING_USERS_PERMISSION_EXTRA_DATA] : ()=>false
})
export default NeedPermissionExtraData
